'use strict';
jQuery($ => {
$(document).ready(() => {

    var companyName = "";

    function removeRows() {
        $('textarea[rows]').removeAttr('rows');
    }

    removeRows();
    $(document).on('gform_post_render', () => {
        removeRows();

        $('.insert-company-name input').val(companyName);
    });

    $('.capture-company-name input').on('change', function(e) {
        companyName = $(this).val();
    });

    $('.gf_readonly').find('input').attr('readonly', 'readonly');

    jQuery(document).on('gform_confirmation_loaded', function(e, formId) {
        let step1 = $('.gecko-builder-demo-form__step--step-1');
        let step2 = $('.gecko-builder-demo-form__step--step-2');

        let step1id = step1.attr('data-step-form-id');
        let step2id = step2.attr('data-step-form-id');

        if (formId == step1id && step2.length > 0) {
            step1.hide();
            step2.show();
        }

        if (formId == step2id && step2.length > 0) {
            let newScrollTop = step2.parents('.gecko-page__builder').offset().top - 116;

            $('html, body').stop().animate({
                scrollTop: newScrollTop
            }, 600);
        }
    });

});
});